import update from 'immutability-helper';
import { generateFormattedPois } from '../utilities/format_pois_util';

import {
  FETCH_MY_PUBLISHED_JOURNAL,
  FETCH_MY_DRAFT_JOURNAL,
  DELETE_JOURNAL,
  CREATE_JOURNAL,
  FETCH_JOURNAL,
  UPDATE_JOURNAL,
  UPLOAD_JOURNAL_COVER_TO_S3,
  UPDATE_JOURNAL_POIS,
  UPDATE_POI_PHOTO,
  RESET_EDIT_JOURNAL,
} from '../actionTypes/journal';
import { EDIT_STATUS } from '../constants/journals';
import { REQUEST } from '../actions/action_types';

const initState = {
  published: {
    ids: [],
    dataById: {},
    isLoading: false,
    dataNext: false,
  },
  draft: {
    ids: [],
    dataById: {},
    isLoading: false,
    dataNext: false,
  },
  edit: {
    currentId: null,
    data: {},
    pois: [],
    poisByMid: {},
    journal: {},
    isLoading: false,
    coverUploadToS3: REQUEST.INIT,
  },
};

export default (state = initState, action) => {
  switch (action.type) {
    case FETCH_MY_PUBLISHED_JOURNAL.LOADING:
      return processLoading(state, EDIT_STATUS.PUBLISHED);
    case FETCH_MY_PUBLISHED_JOURNAL.SUCCESS:
      return processListData(state, action, EDIT_STATUS.PUBLISHED);
    case FETCH_MY_PUBLISHED_JOURNAL.FAIL:
    case FETCH_MY_PUBLISHED_JOURNAL.NEXT_FAIL:
      return processFail(state, EDIT_STATUS.PUBLISHED);
    case FETCH_MY_PUBLISHED_JOURNAL.NEXT_SUCCESS:
      return processListData(state, action, EDIT_STATUS.PUBLISHED, true);
    case FETCH_MY_DRAFT_JOURNAL.LOADING:
      return processLoading(state, EDIT_STATUS.DRAFT);
    case FETCH_MY_DRAFT_JOURNAL.SUCCESS:
      return processListData(state, action, EDIT_STATUS.DRAFT);
    case FETCH_MY_DRAFT_JOURNAL.FAIL:
    case FETCH_MY_DRAFT_JOURNAL.NEXT_FAIL:
      return processFail(state, EDIT_STATUS.DRAFT);
    case FETCH_MY_DRAFT_JOURNAL.NEXT_SUCCESS:
      return processListData(state, action, EDIT_STATUS.DRAFT, true);
    case DELETE_JOURNAL.SUCCESS:
      return processDeleteJournal(state, action);
    case CREATE_JOURNAL.LOADING:
      return {
        ...state,
        edit: {
          ...state.edit,
          isLoading: true,
        },
      };
    case CREATE_JOURNAL.SUCCESS: {
      return {
        ...state,
        edit: {
          ...state.edit,
          isLoading: false,
        },
      };
    }
    case CREATE_JOURNAL.FAIL:
      return {
        ...state,
        edit: {
          ...state.edit,
          isLoading: false,
        },
      };
    case FETCH_JOURNAL.SUCCESS: {
      const { pois, journal, ...rest } = action.payload.results;
      const { dayCount, startTime } = rest;
      const reducePois = pois.map(item => {
        return { ...item.trip, journal: item.journal };
      });
      const poisByMid = pois.reduce((accu, current) => {
        const { journal: poiJournal, ...restPoi } = current;
        // eslint-disable-next-line no-param-reassign
        accu[current.mid] = { ...restPoi, ...poiJournal };
        return accu;
      }, {});
      const itinerary = { dayCount, startTime, pois: reducePois };
      const formattedPois = generateFormattedPois(itinerary);

      return {
        ...state,
        edit: {
          currentId: journal.id,
          data: rest,
          poisByMid,
          pois: formattedPois,
          journal,
          isLoading: false,
        },
      };
    }
    case UPDATE_JOURNAL.SUCCESS: {
      let newEditState = initState.edit;
      newEditState = update(state.edit, {
        journal: { $merge: action.data },
      });

      return {
        ...state,
        edit: newEditState,
      };
    }
    case UPLOAD_JOURNAL_COVER_TO_S3.LOADING:
      return processUploadCoverToS3(state, REQUEST.LOADING);
    case UPLOAD_JOURNAL_COVER_TO_S3.SUCCESS:
      return processUploadCoverToS3(state, REQUEST.SUCCESS);
    case UPLOAD_JOURNAL_COVER_TO_S3.FAIL:
      return processUploadCoverToS3(state, REQUEST.FAIL);
    case UPDATE_JOURNAL_POIS.SUCCESS: {
      const { pois } = action.data;
      const changePois = pois.reduce((accu, current) => {
        const { mid, journal } = current;
        const deletePhotosAry = journal?.photos?.del;
        const updateItem = { ...state.edit.poisByMid[mid] };
        if (deletePhotosAry) {
          const deletedId = deletePhotosAry[0];
          let newUploadPhotosAry = [];
          const newPhotos = updateItem.photos.reduce((photoAry, photo) => {
            if (photo.id !== deletedId) {
              photoAry.push(photo);
            }
            return photoAry;
          }, []);
          if (updateItem?.uploadPhotoAry) {
            newUploadPhotosAry = updateItem.uploadPhotoAry.reduce(
              (uploadPhotoAry, photo) => {
                if (photo.id !== deletedId) {
                  uploadPhotoAry.push(photo);
                }
                return uploadPhotoAry;
              },
              [],
            );
          }

          accu[mid] = {
            ...state.edit.poisByMid[mid],
            photos: newPhotos,
            uploadPhotoAry: newUploadPhotosAry,
          };
        } else {
          accu[mid] = {
            ...state.edit.poisByMid[mid],
            ...journal,
          };
        }

        return accu;
      }, {});

      const newEditState = update(state.edit, {
        poisByMid: { $merge: changePois },
      });

      const newState = {
        ...state,
        edit: newEditState,
      };

      return newState;
    }
    case UPDATE_POI_PHOTO.LOADING: {
      const poi = action.data[0];
      const newPoisByMid = { ...state.edit.poisByMid };
      const uploadPhotoAry = newPoisByMid[poi.mid]?.uploadPhotoAry || [];
      const addPayload = poi.photos.add.map(item => {
        // eslint-disable-next-line no-param-reassign
        item.uploadStatus = REQUEST.LOADING;
        return item;
      });

      const newUploadPhotoAry = uploadPhotoAry.concat(addPayload);
      newPoisByMid[poi.mid].uploadPhotoAry = newUploadPhotoAry;

      const newEditState = update(state.edit, {
        poisByMid: { $merge: newPoisByMid },
      });

      const newState = {
        ...state,
        edit: newEditState,
      };

      return newState;
    }
    case UPDATE_POI_PHOTO.SUCCESS: {
      const { mid, ids } = action.data;
      const newPoisByMid = { ...state.edit.poisByMid };
      newPoisByMid[mid].uploadPhotoAry.forEach((item, index) => {
        if (ids.includes(item.id)) {
          newPoisByMid[mid].uploadPhotoAry[index].upload_url = '';
          newPoisByMid[mid].uploadPhotoAry[index].uploadStatus =
            REQUEST.SUCCESS;
        }
      });

      const newEditState = update(state.edit, {
        poisByMid: { $merge: newPoisByMid },
      });

      const newState = {
        ...state,
        edit: newEditState,
      };

      return newState;
    }
    case UPDATE_POI_PHOTO.FAIL: {
      const { mid, ids } = action.data;
      const newPoisByMid = { ...state.edit.poisByMid };
      newPoisByMid[mid].uploadPhotoAry.forEach((item, index) => {
        if (ids.includes(item.id)) {
          newPoisByMid[mid].uploadPhotoAry[index].uploadStatus = REQUEST.FAIL;
        }
      });

      const newEditState = update(state.edit, {
        poisByMid: { $merge: newPoisByMid },
      });

      const newState = {
        ...state,
        edit: newEditState,
      };

      return newState;
    }
    case RESET_EDIT_JOURNAL:
      return {
        ...state,
        edit: initState.edit,
      };
    default:
      return state;
  }
};

const processListData = (state, action, type, isNeedMerge = false) => {
  const { data, dataNext } = action;
  const ids = data.map(item => {
    return item.id;
  });
  const dataById = data.reduce((accu, current) => {
    accu[current.id] = current;
    return accu;
  }, {});

  let newListState = initState[type];
  if (isNeedMerge) {
    newListState = update(state[type], {
      ids: { $push: ids },
      dataById: { $merge: dataById },
      isLoading: { $set: false },
      dataNext: { $set: dataNext },
    });
  } else {
    newListState = update(state[type], {
      ids: { $set: ids },
      dataById: { $set: dataById },
      isLoading: { $set: false },
      dataNext: { $set: dataNext },
    });
  }

  const newState = {
    ...state,
    [type]: newListState,
  };

  return newState;
};

const processLoading = (state, type) => {
  return {
    ...state,
    [type]: {
      ...state[type],
      isLoading: true,
    },
  };
};

const processFail = (state, type) => {
  return {
    ...state,
    [type]: {
      ...state[type],
      isLoading: false,
      dataNext: false,
    },
  };
};

const processDeleteJournal = (state, action) => {
  const { journalId, journalType } = action;
  const ids = state[journalType].ids;
  const index = ids.indexOf(journalId);
  const newListState = update(state[journalType], {
    ids: { $splice: [[index, 1]] },
    dataById: { $unset: [journalId] },
  });

  return {
    ...state,
    [journalType]: newListState,
  };
};

const processUploadCoverToS3 = (state, status) => {
  return {
    ...state,
    edit: {
      ...state.edit,
      coverUploadToS3: status,
    },
  };
};
